import {CountriesWithCurrencies, CurrencyFlagCountryCodes} from '../../commons/data/countiresWithCurrencies';

const countryCodeToFlagEmoji = (countryCode?: string) =>
  countryCode?.replace(/./g, (char) => String.fromCodePoint(127397 + char.toUpperCase().charCodeAt(0)));

export const useCountryInfoHook = (suggestedCurrencyCode: string) => {
  const userCountryInfo = CountriesWithCurrencies.find((c) => c.currency === suggestedCurrencyCode);
  const flagCountryCode = userCountryInfo
    ? CurrencyFlagCountryCodes[userCountryInfo.currency] ?? userCountryInfo.id
    : undefined;

  return {
    userCountryInfo: userCountryInfo
      ? {
          ...userCountryInfo,
          flagCountryCode,
          flagEmoji: countryCodeToFlagEmoji(flagCountryCode),
        }
      : undefined,
  };
};
